var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('masterList',{attrs:{"tableColumns":_vm.tableColumns,"module":'users',"addNew":_vm.addNew}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }